import React, { Component } from "react";
import PropTypes from "prop-types";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import CloseIcon from "@material-ui/icons/Close";
import { Button } from "../../../shared/widgets";

class CollectionHandledByErrorModal extends Component {
  close = () => {
    const { closeHandler } = this.props;
    closeHandler();
  };

  render() {
    const {
      showModal, content, defaultContent, title,
    } = this.props;
    return (
      <Dialog
        onClose={this.close}
        aria-labelledby="customized-dialog-title"
        open={showModal}
        className="settlementDialogWrapper"
      >
        <DialogTitle id="customized-dialog-title" onClose={this.close}>
          <div className="modalHeaderWrapper">
            <div className="dialogTitle">{title}</div>
            <div role="button" className="closeIcon" onClick={this.close} onKeyDown={() => { /* onKeyDown */ }} tabIndex="0" aria-label="close">
              <CloseIcon />
            </div>
          </div>
        </DialogTitle>
        <DialogContent dividers>
          <div>
            {defaultContent}
          </div>
          <div>
            {content}
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.close} buttonText="Close" />
        </DialogActions>
      </Dialog>
    );
  }
}

CollectionHandledByErrorModal.defaultProps = {
  showModal: false,
  defaultContent: "Please select \"Collection Handled By\" for following vehicles:",
  title: "",
};
CollectionHandledByErrorModal.propTypes = {
  showModal: PropTypes.bool,
  // eslint-disable-next-line react/require-default-props
  closeHandler: PropTypes.func,
  defaultContent: PropTypes.string,
  title: PropTypes.string,
};

export default CollectionHandledByErrorModal;
